import { UploadFail } from 'reactApp/modules/uploading/fails/UploadFail';

export class WrongDestinationPathFail extends UploadFail {
    static WEB_BACKEND_ERROR = 'not_dir';

    radarName = 'fail_{SOURCE}_wrong-path';
    message = 'Путь, по которому вы пытаетесь загрузить папку, является файлом.';
}
